<template lang="pug">
.signatures-list
  ul.mb-0
    li
      p {{ $t('recipient') }}
      .signature-name.text-overflow-ellipse(:title='this.addressee.name')
        span {{ this.addressee.name }}
      .signature-name.text-overflow-ellipse(:title='this.addressee.value')
        span {{ this.addressee.value }}
    li(v-if='envelope')
      .signature-status(:class='envelope.state')
        icon-status(:icon-status='envelope.state')
        span.text.ms-2(style='font-weight: 600') {{ $t('signaturesList.envelopeState', { state: envelopeStateText }) }}
      .signature-name {{ $t('signaturesList.envelopeDescription', { description: envelopeStateDescription }) }}
</template>

<script>
import IconStatus from '@/ui/atoms/IconStatus.vue';
import EnvelopeState from '@/enums/EnvelopeState';
export default {
  name: 'AddresseeList',
  components: {
    IconStatus,
  },
  props: {
    envelope: {
      type: Object,
      required: false,
    },
    addressee: {
      type: Object,
      required: true,
    },
  },
  computed: {
    envelopeStateText() {
      return EnvelopeState.getText(
        this.envelope.state,
        this.$i18n
      ).toLowerCase();
    },
    envelopeStateDescription() {
      return EnvelopeState.getDescription(
        this.envelope.state,
        this.$i18n
      ).toLowerCase();
    },
  },
};
</script>
<style scoped lang="stylus">
.signatures-list
  ul
    margin: 0 0 20px 0
    padding: 1rem
    list-style: none
    border: 1px solid rgba(204, 204, 204, .7)
    border-radius: 5px

    li
      padding: 0.75rem 0
      border-bottom: 1px solid rgba(204, 204, 204, .7)
      height: auto

      p
        margin: 0
        font-weight: 600

      &:first-child
        padding-top: 0

      &:last-child
        padding-bottom: 0
        border-bottom: none

      span
        font-size: 0.85rem
</style>
